var map = {
	"./Accounts-depart.jpg": 213,
	"./Administration.jpg": 214,
	"./Billing-area.jpg": 215,
	"./Front-Desk-Department.jpg": 216,
	"./Front-desk.jpg": 217,
	"./Lab-department.jpg": 218,
	"./Photography-department.jpg": 219,
	"./Procedure-Technicians.jpg": 220,
	"./acacnescar.jpg": 221,
	"./acne-scar.JPG": 222,
	"./acne-scar.pdf": 223,
	"./acne-vulgaris.JPG": 224,
	"./acne-vulgarisp.pdf": 225,
	"./acnescarp.pdf": 226,
	"./aliopecia-areata.JPG": 227,
	"./aliopecia-areatap.pdf": 228,
	"./androgenetic-alopecia.JPG": 229,
	"./androgenetic-alopeciap.pdf": 230,
	"./anti-ageing.JPG": 231,
	"./anti-ageing.pdf": 232,
	"./atopic-dermatitis.JPG": 233,
	"./atopic-dermatitisp.pdf": 234,
	"./botox.JPG": 235,
	"./botox.pdf": 236,
	"./chemical-peels.JPG": 237,
	"./chemical-peels.pdf": 238,
	"./chronic-telogen-effluvium.JPG": 239,
	"./chronic-telogen-effluviump.pdf": 240,
	"./dermal-fillers.JPG": 241,
	"./dermal-fillers.pdf": 242,
	"./fphl.JPG": 243,
	"./fphlp.pdf": 244,
	"./fungal-tinea-Infection.JPG": 245,
	"./fungal-tinea-Infectionp.pdf": 246,
	"./hair-transplantation.JPG": 247,
	"./hair-transplantation.pdf": 248,
	"./hair-transplantationp.pdf": 249,
	"./laser-hair-removal.JPG": 250,
	"./laser-hair-removal.pdf": 251,
	"./laser-hair-removalp.pdf": 252,
	"./lichen-planus-pigmentosus.JPG": 253,
	"./lichen-planus-pigmentosusp.pdf": 254,
	"./lllt.JPG": 255,
	"./llltp.pdf": 256,
	"./melasma.JPG": 257,
	"./melasmap.pdf": 258,
	"./moles-removal.JPG": 259,
	"./moles-removal.pdf": 260,
	"./papular-urticaria.JPG": 261,
	"./papular-urticariap.pdf": 262,
	"./prp.JPG": 263,
	"./prp.pdf": 264,
	"./psoriasis-front.JPG": 265,
	"./psoriasis-frontp.pdf": 266,
	"./radio-surgery.JPG": 267,
	"./radio-surgery.pdf": 268,
	"./sclerotherapy.JPG": 269,
	"./sclerotherapy.pdf": 270,
	"./service-at-cutis.JPG": 271,
	"./service-at-cutis.pdf": 272,
	"./urticaria.JPG": 273,
	"./urticariap.pdf": 274,
	"./vitiligo-front.JPG": 275,
	"./vitiligo-frontp.pdf": 276,
	"./vitiligo-surgery.JPG": 277,
	"./vitiligo-surgery.pdf": 278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;